<div #listTop class="flex flex-row justify-start items-center gap-2 mb-2">
    <h5 class="mb-0">{{ title }}</h5>
    <div class="flex flex-grow"></div>
    <button class="btn btn-primary gap-2" [disabled]="!fullProduct()" (click)="add()">
        <iota-icon icon="plus"></iota-icon>
        <span i18n>Add / Overwrite </span>
    </button>
</div>

<div class="flex flex-col justify-start items-stretch gap-2" cdkDropList (cdkDropListDropped)="drop($event)">
    <app-product-pricing-option
        *ngFor="let pricingOption of pricingOptionsToDisplay; let i = index"
        [editable]="isEditable(pricingOption)"
        [duplicable]="!!fullProduct()"
        [pricingOption]="pricingOption"
        [allPricingOptions]="pricingOptionsToDisplay"
        [companyProductSelection]="companyProductSelection"
        [priceScaleState]="priceScaleState()"
        (save)="save($event, i)"
        (delete)="deletePricingOption($event)"
        (cancelEdit)="checkCancel(pricingOption)"
        (duplicate)="duplicatePricingOption($event)"
    >
    </app-product-pricing-option>
</div>
